<template>
  <div>
    <loading-spinner v-if="loading" class="mt-2"/>
    <div v-if="editing" class="settings-button d-inline-block mb-1" @click="showSelector = true">add assemblies</div>
    <portal v-if="editing && showSelector" to="pageOverlay">
      <popup
          :elevated-z-index="10000"
          @close="showSelector = false"
      >
        <assembly-selector
            slot="popupMainContent"
            :organization-id="organizationIds[0]"
            :pre-selected-objects="selectedAssemblies && selectedAssemblies.length ? selectedAssemblies.map(id => {return {id: id}}) : []"
            @selectObjects="selectAssemblies"
        />
      </popup>
    </portal>
    <div>
      <div
          v-for="assemblyId in selectedAssemblies"
          :key="assemblyId" class="mt-1">
        <assembly-partner
            :assembly-id="assemblyId"
            :assembly-name="$store.getters.getSfxdataName(assemblyId, listName) || $store.getters.getSfxdataName(assemblyId, listName2) || 'Loading...'"
            :editing="editing"
            :value="value"
            :list-name="listName"
            @remove="removeAssembly"
        />
      </div>
    </div>
    <div
        v-if="editing"
        @click="$emit('save', JSON.stringify(selectedAssemblies))"
        class="settings-button d-inline-block">
      {{ $t('save') }}
    </div>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import AssemblyPartner from "@/components/widgets/editors/AssemblyPartnerOptions/AssemblyPartner.vue";
import AssemblySelector from "@/components/bluePrint/AssemblySelector.vue";
import Popup from "@/components/Popup.vue";

export default {
  name: "AssemblyPartnerOptions",
  components: {
    AssemblySelector,
    LoadingSpinner,
    AssemblyPartner,
    Popup,
  },
  props: {
    value: {type: String, default: ''},
    editing: {type: Boolean, default: true},
    organizationIds: {type: Array, default: null},
  },
  data() {
    return {
      selectedAssemblies: [],
      loading: false,
      showSelector: false,
      listName: "SfxdataListSelector",
      listName2: "SelectedSfxdataListSelector",
    };
  },
  watch: {
    value: {
      handler() {
        this.setAssembliesFromValue();
      }
    }
  },
  beforeMount() {
    this.setAssembliesFromValue();
  },
  methods: {
    setAssembliesFromValue() {
      // parse value as json array
      try {
        this.selectedAssemblies = JSON.parse(this.value);
      } catch (e) {
        this.selectedAssemblies = [];
      }
      this.loadAssembliesIfMissing();
    },
    selectAssemblies(selectedAssemblies) {
      console.log('selectAssemblies method', selectedAssemblies);
      let preSelectedAssemblies = JSON.parse(JSON.stringify(this.selectedAssemblies));
      if(!preSelectedAssemblies) {
        preSelectedAssemblies = [];
      }
      for(let i = 0; i < selectedAssemblies.length; i++) {

        // selectedAssemblies have [{id: 'assemblyId'}, ...]
        // preSelectedAssemblies have ['assemblyId', ...]
        const alreadySelected = !preSelectedAssemblies || preSelectedAssemblies.includes(selectedAssemblies[i].id);
        if(!alreadySelected) {
          preSelectedAssemblies.push(selectedAssemblies[i].id);
        }
      }
      if(preSelectedAssemblies && preSelectedAssemblies > 0) {
        for(let i = 0; i < preSelectedAssemblies.length; i++) {
          const hasExistingItemInSelected = selectedAssemblies.find(a => a.id === preSelectedAssemblies[i]);
          if(!hasExistingItemInSelected) {
            preSelectedAssemblies.splice(i, 1);
            i--;
          }
        }
      }
      console.log('new preSelectedAssemblies', preSelectedAssemblies);
      this.$set(this, 'selectedAssemblies', preSelectedAssemblies);
      this.showSelector = false;
    },
    selectAssembly(assembly) {
      console.log('selectAssembly', assembly);
      this.selectedAssemblies.push(assembly.id);
    },
    removeAssembly(assemblyId) {
      console.log('removeAssembly', assemblyId);
      let assemblyArray = JSON.parse(JSON.stringify(this.selectedAssemblies));
      assemblyArray = assemblyArray.filter(a => a !== assemblyId);
      console.log('new assemblyArray', assemblyArray);
      this.$set(this, 'selectedAssemblies', assemblyArray);
    },
    async loadAssembliesIfMissing() {
      let assemblyIds = JSON.parse(JSON.stringify(this.selectedAssemblies));
      console.log('loadAssembliesIfMissing for ids', assemblyIds);
      if(!assemblyIds || assemblyIds.length === 0) {
        return;
      }
      for(let i = 0; i < assemblyIds.length; i++) {
        if(this.$store.getters.getSfxdataName(assemblyIds[i], this.listName) && this.$store.getters.getSfxdataName(assemblyIds[i], this.listName2)) {
          assemblyIds.splice(i, 1);
          i--;
        }
      }
      console.log('loading assemblies for ids', assemblyIds);
      if (!assemblyIds || assemblyIds.length === 0) {
        return;
      }
      const filter = assemblyIds.length > 1 ?
          `id in ${assemblyIds.map(id => `'${id}'`).join(' ')}` :
          `id eq ${assemblyIds[0]}`;
      console.log('loading with filter', filter);
      await this.$store.dispatch('loadSfxdatas', {
        listName: this.listName2,
        add: {
          filter: {
            [this.listName2]: filter
          }
        },
      });
    }
    /* async loadAssemblies() {
       this.loading = true;
       // organizationId eq 'org123' or organizationId in 'org12' 'org34'
       const orgFilter = this.organizationIds.length > 1 ?
           `organizationId in ${this.organizationIds.map(id => `"${id}"`).join(' ')}"` :
           `organizationId eq ${this.organizationIds[0]}`;
       const filter = `${orgFilter}, type eq assembly`;
       this.assemblies = await this.$store.dispatch('clientLoadAssets', {
         filter
       });
       this.loading = false;
       // Load assemblies based on organizationIds
     },*/
  }
}
</script>

<style lang="scss" scoped>

</style>